/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![UserCircleIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAACMUlEQVR4nMVVS4sUQQzuiy/Q1RVPvtAFT/4AHxevDd2ppAdrkp4Wx4M76k/w4B486y9R8A2Cgge9igjqQZiDi+cdXPWgLqukZ3qs6amenl4EA4GmK5Xky5ekguB/irV2PxD3gPihQe4b4rVckftA/AAxvRxFncWtON5lSG4CyldD8nu28hdDvBKG4Y65nEetzhIQv6l3LJOK8hqRj810rgZAsurJcs2QLBsjB1VHZRt4An2KY3vU61whGuK3nku/jJFTZXtI2qcBZaNsr+ittdunAmjNfdAB+XEVYiB+UsHLymTdo87ikCyv8a3KACi3vUkRD8IwW3Czv1pFHmwJQa7LfwOg3K8OIBs+DmJKz/g4cJDfdQLoEFW3IBAPtHOKLkJMr1R0kdO2/NGt5Y/GfU+1A/jN5eB7heGm1hmROzojvV5vmyqAPW6SdjbiYLNqwh2yvMP1zlf7siDyWR0wT4n6DgK+VzJ4bq3dXed8THicHgCSFyXe7njbFEjeG2P2BA0lDLMFQPlQ+NFNOz601u5VUvJD077Y1HkheneU5PpUkoB8o2gvPQSQk8bI+aBGgLiltoogvzsMcH3K8Fy3u3O8ppFfAvFTxBTmCBCrrUF5VaztyrdBV60h+TwmK2ln9QHkgsPfapJkh2deQOQj7toGkmeAfClqpSf0pVPVb/2n3eau6Siyh4J5RCEqJ/M8mUObBk/mJJruPiC+phtV4QPyT10r+WCiPNIztWns+F/KH5bbKTBPMSq+AAAAAElFTkSuQmCC)
 */
export const UserCircleIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        fillRule="evenodd"
        d="M18.46 20.9a12.65 12.65 0 0 1-1.46.9 10.95 10.95 0 0 1-10 0 11 11 0 1 1 11.46-.9Zm-1.65-1.3a8.96 8.96 0 0 1-9.62 0l.23-2.26c.02-.25-.27-.36-.41-.15-.29.45-.6 1.01-.88 1.63A9.04 9.04 0 0 1 4.2 16.5a9 9 0 0 1 15.6 0 9.04 9.04 0 0 1-1.93 2.32c-.27-.62-.59-1.18-.88-1.63-.14-.21-.43-.1-.4.15l.22 2.27ZM12 11a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Z"
        clipRule="evenodd"
        className={colorClass}
      />
    </svg>
  );
};
